import { KYMW6900Model } from "../../kymw6900/kymw6900.model";
import { BuyerListModel } from "../../kymw6900/vo/buyer-model";
import { GoodsModel } from "../../kymw6902/vo/goods.model";
import { KYMW6901Component } from "../kymw6901.component";
import { KYMW6901Model } from "../kymw6901.model";
import { NewGoodsProposalModel } from "./vo/new-goods-proposal.model";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";

export class KYMW6901ProposalTabModel {
  parent: KYMW6901Component;

  loginUser: { userId: string, associatedUserType: string, userClassList?: { classCode: string; userClass: string; }[]; };

  coopMap: { [key: string]: string; };
  classCodeList = [];
  buyerList: BuyerListModel = [];
  temperatureDivList = [];
  newGoodsProposal = new NewGoodsProposalModel();
  hasChanged = false;
  existingGoods = new GoodsModel();

  disabledSettings = {
    copyProposal: false,
    classCode: false,
    buyerUserId: false,
    goodsName: false,
    standardName: false,
    janCode: false,
    salesPoint: false,
    standardSellingPrice: false,
    special1SellingPrice: false,
    special2SellingPrice: false,
    standardCostPrice: false,
    special1CostPrice: false,
    special2CostPrice: false,
    expirationDate: false,
    bestBeforeDate: false,
    preferredOrderCode: false,
    preferredDelivCatalogId: false,
    preferredExpansionDiv1: false,
    preferredExpansionDiv2: false,
    preferredExpansionDiv3: false,
    preferredExpansionDiv4: false,
    preferredExpansionOther: false,
    allCoop: false,
    ibaraki: false,
    tochigi: false,
    gunma: false,
    chiba: false,
    saitama: false,
    tokyo: false,
    nagano: false,
    niigata: false,
    monthAge: false,
    productionFactory: false,
    manufacturingFactory: false,
    deliGoodsChecked: false,
    goodsCheckRequest: false,
    temperatureDiv: false,
    orderClientName: false,
    markerName: false,
    allergen: false,
    additives: false,
    cookingMethod: false,
    mobRegistered: false,
    shootingInstruction: false,
    uploadImage: false,
    imageFileName: false,
    outputImage: false,
    shootingImage: false,
    note: false,
    rejectedReason: false,
    predictedPoints: false
  };


  private validations = [
    {
      validate: () => !!this.newGoodsProposal.classCode,
      code: 'W0001',
      message: ['部門名']
    },
    {
      validate: () => !!this.newGoodsProposal.buyerUserId,
      code: 'W0001',
      message: ['商品担当者']
    },
    {
      validate: () => !!this.newGoodsProposal.goodsName,
      code: 'W0001',
      message: ['商品名']
    },
    {
      validate: () => !!this.newGoodsProposal.standardName,
      code: 'W0001',
      message: ['規格名']
    },
    {
      validate: () => {
        const [integer, decimal] = this.newGoodsProposal.standardCostPrice.split('.');
        if (!decimal) {
          return integer.length <= 7;
        }
        return integer.length <= 7 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['希望価格（仕入価）／通常', '7', '2']
    },
    {
      validate: () => {
        const [integer, decimal] = this.newGoodsProposal.special1CostPrice.split('.');
        if (!decimal) {
          return integer.length <= 7;
        }
        return integer.length <= 7 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['希望価格（仕入価）／特１', '7', '2']
    },
    {
      validate: () => {
        const [integer, decimal] = this.newGoodsProposal.special2CostPrice.split('.');
        if (!decimal) {
          return integer.length <= 7;
        }
        return integer.length <= 7 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['希望価格（仕入価）／特２', '7', '2']
    },
    {
      validate: () => {
        if (!this.newGoodsProposal.preferredOrderCode) {
          return true;
        }
        return this.newGoodsProposal.preferredOrderCode.length === 7;
      },
      code: 'W0024',
      message: ['展開開始希望受注コード']
    },
    {
      validate: () => {
        if (!this.newGoodsProposal.preferredDelivCatalogId) {
          return true;
        }
        return this.newGoodsProposal.preferredDelivCatalogId.length === 8;
      },
      code: 'W0024',
      message: ['展開開始希望企画回']
    },
    {
      validate: () => !!this.newGoodsProposal.preferredExpansionDiv,
      code: 'W0001',
      message: ['希望展開区分']
    },
    {
      validate: () => {
        if (this.newGoodsProposal.preferredExpansionDiv !== '4') {
          return true;
        }
        return !!this.newGoodsProposal.preferredExpansionOther;
      },
      code: 'W0001',
      message: ['希望展開区分／その他']
    },
    {
      validate: () => {
        if (this.newGoodsProposal.preferredExpansionDiv !== '4') {
          return true;
        }
        return this.newGoodsProposal.preferredExpansionOther.length <= 30;
      },
      code: 'W0007',
      message: ['希望展開区分／その他', '30']
    },
    {
      validate: () => {
          return !(this.newGoodsProposal.preferredOrderCode && !this.newGoodsProposal.preferredDelivCatalogId);
      },
      code: 'W0024',
      message: ['展開開始希望受注コード']
    },
    {
      validate: () => {
        return !(!this.newGoodsProposal.preferredOrderCode && this.newGoodsProposal.preferredDelivCatalogId);
      },
      code: 'W0024',
      message: ['展開開始希望企画回']
    },
  ];

  setDisabled(isDisabled: boolean, excludeElements: (keyof typeof this.disabledSettings)[] = []) {
    this.disabledSettings = Object.keys(this.disabledSettings)
      .reduce((prev, elementName) => {
        if (excludeElements.includes(elementName as (keyof typeof this.disabledSettings))) {
          return prev;
        }
        return { ...prev, [elementName]: isDisabled };
      }, { ...this.disabledSettings });
  }

  validate() {
    const error = this.validations.find(v => !v.validate());
    if (!error) {
      return null;
    }
    return { code: error.code, message: error.message };
  }

  setCoopMap(coopMap: { [key: string]: string; }) {
    this.coopMap = { ...coopMap };
  }
  toCoopMap(coopCodes: string[]) {
    const result = coopCodes.reduce((prev, coop) => {
      const coopName = this.coopMap[coop];
      return {
        ...prev,
        [coopName]: true,
      };
    }, this.newGoodsProposal.expandableCoop);
    return result;
  }

  clearOriginProposalInfo() {
    this.newGoodsProposal.proposalId = '';
    this.newGoodsProposal.proposalStatus = '';
  }

  setBuyerList(buyerList: BuyerListModel) {
    this.buyerList = [...buyerList];
  }

  static calcGpr(sellingPrice: string, costPrice: string) {
    if (!sellingPrice || !costPrice) {
      return '';
    }
    // 売価が0の場合、GPRに0を設定
    if (Number(sellingPrice) === 0) {
      return '0';
    }
    const gpr = ((Number(sellingPrice) - Number(costPrice)) / Number(sellingPrice) * 100).toFixed(2);
    return gpr.toString();
  }

  userId() {
    return this.loginUser.userId;
  }

  isBuyer() {
    return !!this.loginUser.userClassList.find(userClass => {
      return userClass.userClass === KYMW6901Model.USER_CLASS_STAFF
        || userClass.userClass === KYMW6901Model.USER_CLASS_AGENT;
    });
  }

  isGroupLeader() {
    return !!this.loginUser.userClassList.find(userClass => userClass.userClass === KYMW6901Model.USER_CLASS_LEADER);
  }

  isBeforeProposing() {
    return !this.newGoodsProposal.proposalStatus
      || this.newGoodsProposal.proposalStatus === KYMW6900Model.PROPOSAL_STATUS_PROPOSAL_BEFORE;
  }

  isBuyerEditable() {
    return this.isBuyer() && this.newGoodsProposal.proposalStatus === KYMW6900Model.PROPOSAL_STATUS_PROPOSING;
  }

  isDisplayRejectedReason() {
    return this.isBuyer() && !PlessViewUtilsSub.isEmpty(this.newGoodsProposal.proposalStatus) && this.newGoodsProposal.proposalStatus !== KYMW6900Model.PROPOSAL_STATUS_PROPOSAL_BEFORE;
  }

  expandableCoopToCoopCodeList() {
    const result = Object.entries(this.newGoodsProposal.expandableCoop)
      .filter(([, checked]) => checked)
      .reduce((prev, [coopName]) => {
        const coopCode = Object.keys(this.coopMap).find(key => this.coopMap[key] === coopName);
        if (coopCode) {
          return [...prev, coopCode];
        }
        return prev;
      }, []);

    return result;
  }

}